module.exports = __webpack_public_path__ + "static/tutorial-hell-eb38ded8f8e052181626da7c90658aa0.svg";